import { render, staticRenderFns } from "./aiChatArea.vue?vue&type=template&id=67d4cf30&scoped=true"
import script from "./aiChatArea.vue?vue&type=script&lang=js"
export * from "./aiChatArea.vue?vue&type=script&lang=js"
import style0 from "./aiChatArea.vue?vue&type=style&index=0&id=67d4cf30&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67d4cf30",
  null
  
)

export default component.exports